/**
 * Assignment StartDate / FinishDate helpers (DD/MM/YYYY), matching the API
 * boundary validator in Pacific.Agentic.Api component_matching_import models.
 */

/** Parse a DD/MM/YYYY cell; empty → null; malformed / impossible calendar → "invalid". */
export function parseAssignmentDateDdMmYyyy(
  raw: string
): Date | null | "invalid" {
  const trimmed = raw.trim();
  if (trimmed === "") return null;
  const match = /^(\d{1,2})\/(\d{1,2})\/(\d{4})$/.exec(trimmed);
  if (!match) return "invalid";
  const day = Number(match[1]);
  const month = Number(match[2]);
  const year = Number(match[3]);
  const date = new Date(year, month - 1, day);
  if (
    date.getFullYear() !== year ||
    date.getMonth() !== month - 1 ||
    date.getDate() !== day
  ) {
    return "invalid";
  }
  return date;
}

/** Client-side date pair checks aligned with API R-APP-3b. */
export function assignmentDatePairErrors(
  startRaw: string,
  finishRaw: string
): string[] {
  const hasStart = startRaw.trim() !== "";
  const hasFinish = finishRaw.trim() !== "";
  if (hasStart !== hasFinish) {
    return ["StartDate and FinishDate must both be set or both omitted."];
  }
  if (!hasStart && !hasFinish) return [];

  const start = parseAssignmentDateDdMmYyyy(startRaw);
  const finish = parseAssignmentDateDdMmYyyy(finishRaw);
  const errors: string[] = [];
  if (start === "invalid") {
    errors.push(`StartDate "${startRaw.trim()}" must be DD/MM/YYYY.`);
  }
  if (finish === "invalid") {
    errors.push(`FinishDate "${finishRaw.trim()}" must be DD/MM/YYYY.`);
  }
  if (start instanceof Date && finish instanceof Date && finish < start) {
    errors.push(
      `FinishDate "${finishRaw.trim()}" must be on or after StartDate "${startRaw.trim()}".`
    );
  }
  return errors;
}
